/**
 * @generated SignedSource<<4570edf821e56ce98febc1c3f1c9b076>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_IssueNavigatorUI_project$data = {
  readonly conditionalFormattingRules?: {
    readonly edges: ReadonlyArray<{
      readonly __typename: "JiraFormattingRuleEdge";
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly name?: string;
  readonly projectId: string | null | undefined;
  readonly projectType: JiraProjectType | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"MigrateListConfigClickListener_JiraProject" | "main_issueNavigator_IssueResults_project" | "main_issueNavigator_SidebarLayout_project" | "topBar_issueNavigator_projectResult">;
  readonly " $fragmentType": "main_issueNavigator_IssueNavigatorUI_project";
};
export type main_issueNavigator_IssueNavigatorUI_project$key = {
  readonly " $data"?: main_issueNavigator_IssueNavigatorUI_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigatorUI_project">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "isConditionalFormattingEnabled",
  "variableName": "isConditionalFormattingEnabled"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjirapaidlistninmergeonboardingmodalenabledrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisninsavedfiltersenabledrelayprovider"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isSavedViewConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "main_issueNavigator_IssueNavigatorUI_project",
  "selections": [
    {
      "args": [
        (v0/*: any*/)
      ],
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_IssueResults_project"
    },
    {
      "args": [
        (v0/*: any*/),
        {
          "kind": "Variable",
          "name": "isSavedViewConditionalFormattingEnabled",
          "variableName": "isSavedViewConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_SidebarLayout_project"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisninsavedfiltersenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "topBar_issueNavigator_projectResult"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "MigrateListConfigClickListener_JiraProject"
    },
    {
      "kind": "ScalarField",
      "name": "projectId"
    },
    {
      "kind": "ScalarField",
      "name": "projectType"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjirapaidlistninmergeonboardingmodalenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    },
    {
      "condition": "isSavedViewConditionalFormattingEnabled",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "condition": "isConditionalFormattingEnabled",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 20
                }
              ],
              "concreteType": "JiraFormattingRuleConnection",
              "kind": "LinkedField",
              "name": "conditionalFormattingRules",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraFormattingRuleEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "__typename"
                    }
                  ]
                }
              ],
              "storageKey": "conditionalFormattingRules(first:20)"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraProject"
};
})();

(node as any).hash = "d47e4df8a2390d4bed54a07fd4525b91";

export default node;
